import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  meta: {
    totalCount: 0,
    count: 0,
    currentPage: 1,
    perPage: 10,
  },
  reportmeta: {
    totalCount: 0,
    count: 0,
    currentPage: 1,
    perPage: 10,
  },
  reports: {},
  records: {},
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isUpdating: false,
    isMerging: false,
    isDeleting: false,
    // Per-contact fetch state for `contactable_inboxes`, keyed by contact id.
    // A single global boolean caused a race: one contact's fetch finishing
    // cleared the flag while another contact's fetch was still in flight,
    // making the New Conversation modal wrongly show the "no inbox" alert.
    contactableInboxesFetching: {},
    // Per-contact failure marker so the UI can show a retry state instead of
    // a silently empty inbox dropdown after a failed fetch.
    contactableInboxesFailed: {},
  },
  sortOrder: [],
  appliedFilters: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
